import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import LoadingSpinner from './components/LoadingSpinner'
import MobileWarning from './components/MobileWarning'

const Login = lazy(() => import('./pages/Login'))
const Campaigns = lazy(() => import('./pages/Campaigns'))
const CampaignEditor = lazy(() => import('./pages/CampaignEditor'))
const CampaignDetail = lazy(() => import('./pages/CampaignDetail'))
const UserManagement = lazy(() => import('./pages/UserManagement'))
const Templates = lazy(() => import('./pages/Templates'))
const TemplateEditor = lazy(() => import('./pages/TemplateEditor'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const TermsOfService = lazy(() => import('./pages/TermsOfService'))

function App() {
  const { user, loading } = useAuth()
  const isAuthenticated =  Boolean(user)

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <Suspense
      fallback={(
        <div className="min-h-screen flex items-center justify-center">
          <LoadingSpinner size="lg" />
        </div>
      )}
    >
      <>
        <MobileWarning />
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route
            path="/login"
            element={isAuthenticated ? <Navigate to="/campaigns" /> : <Login />}
          />
          <Route element={<ProtectedRoute isAuthenticated={isAuthenticated} />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/campaigns" replace />} />
              <Route path="mail-merge" element={<Navigate to="/campaigns/new" replace />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaigns/new" element={<CampaignEditor />} />
              <Route path="campaigns/:campaignId" element={<CampaignDetail />} />
              <Route path="campaigns/:campaignId/edit" element={<CampaignEditor />} />
              <Route path="templates" element={<Templates />} />
              <Route path="templates/new" element={<TemplateEditor />} />
              <Route path="templates/:templateId/edit" element={<TemplateEditor />} />
              <Route path="users" element={<UserManagement />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to={isAuthenticated ? '/campaigns' : '/login'} replace />} />
        </Routes>
      </>
    </Suspense>
  )
}

export default App
